// extracted by mini-css-extract-plugin
export default {"checkboxInput":"CheckboxInput_checkboxInput__oerA7","error":"CheckboxInput_error__RA01C"};